import React, { useState } from 'react';
import 'whatwg-fetch';
import logoHipcom from 'src/images/logoAlpha.png';
import { Controller, useForm } from 'react-hook-form';
import { PostLoginRequestBody } from 'src/interfaces/api/User';
import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid,
  Hidden,
  InputLabel,
  OutlinedInput,
} from '@material-ui/core';
import styles from './Login.styles';
import useAuth from '../../hooks/api/useAuth';
import { Redirect } from 'react-router';
import { Alert } from '@material-ui/lab';
import { createUseStyles } from 'src/theming';

const useStyles = createUseStyles(styles);

const Login = () => {
  const [formError, setFormError] = useState(false);
  const { login, authenticated } = useAuth();
  const classes = useStyles();

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm<PostLoginRequestBody>({
    defaultValues: {
      username: '',
      password: '',
    },
  });

  const onSubmit = async ({ username, password }: PostLoginRequestBody) => {
    setFormError(false);

    try {
      await login(username, password);
    } catch (e) {
      setFormError(true);
    }
  };

  if (authenticated) {
    return <Redirect to='/dashboard/home' />;
  }

  return (
    <Grid container className={classes.root}>
      <Hidden smDown>
        <Grid item md={4} lg={5} className={classes.featurePanel} />
      </Hidden>

      <Grid item xs={12} md={8} lg={7} className={classes.mainPanel}>
        <Grid container className={classes.row}>
          <Grid item md={10} lg={8} xl={6} className='m-auto px-3'>
            <Box display='flex' marginBottom='30px' flexDirection='row' alignItems='center' justifyContent='center'>
              <img src={logoHipcom} width={70} height={70} alt='logo' />
              <Box marginLeft='1rem' component='span' fontSize='2.5rem'>
                Scaleed
              </Box>
            </Box>

            {formError && (
              <Box marginBottom='30px' clone>
                <Alert color='error' severity='error'>
                  <strong>Erreur ! </strong> Veuillez revoir vos identifiants.
                </Alert>
              </Box>
            )}

            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Controller
                    name='username'
                    control={control}
                    rules={{ required: { value: true, message: 'Le champ est requis' } }}
                    render={({ field, fieldState: { error } }) => (
                      <FormControl error={error !== undefined} fullWidth variant='outlined'>
                        <InputLabel htmlFor={field.name}>Nom d'utilisateur</InputLabel>
                        <OutlinedInput {...field} label="Nom d'utilisateur" id={field.name} labelWidth={60} />
                        {error && <FormHelperText>{error.message}</FormHelperText>}
                      </FormControl>
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Controller
                    name='password'
                    control={control}
                    rules={{ required: { value: true, message: 'Le champ est requis' } }}
                    render={({ field, fieldState: { error } }) => (
                      <FormControl error={error !== undefined} fullWidth variant='outlined'>
                        <InputLabel htmlFor={field.name}>Mot de passe</InputLabel>
                        <OutlinedInput
                          {...field}
                          label='Mot de passe'
                          type='password'
                          id={field.name}
                          labelWidth={60}
                        />
                        {error && <FormHelperText>{error.message}</FormHelperText>}
                      </FormControl>
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button
                    classes={{
                      root: classes.button,
                      label: classes.buttonLabel,
                    }}
                    type='submit'
                    color='inherit'
                    variant='contained'
                    disabled={isSubmitting}
                  >
                    Valider {isSubmitting && <CircularProgress color='inherit' size={15} />}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Login;
